export enum ISFAPI {
  'CREATE_MILESTONE' = 'CREATE_MILESTONE',
  'GET_IP_RELEASE_DOCS' = 'GET_IP_RELEASE_DOCS',
  'GET_IP_RELEASE_STATUS' = 'GET_IP_RELEASE_STATUS',
  'CREATE_SIV_CHECKLIST' = 'CREATE_SIV_CHECKLIST',
  'GET_ALL_SITE_PERSONNEL' = 'GET_ALL_SITE_PERSONNEL',
  'GET_REQUEST_ACCESS_PERSONNEL' = 'GET_REQUEST_ACCESS_PERSONNEL',
  'CREATE_SIV_REPORT' = 'CREATE_SIV_REPORT',
  'CREATE_BUDGET' = 'CREATE_BUDGET',
  'UPDATE_BUDGET' = 'UPDATE_BUDGET',
  'UPDATE_SIV_CHECKLIST' = 'UPDATE_SIV_CHECKLIST',
  'CREATE_STUDY' = 'CREATE_STUDY',
  'UPDATE_IP_SUPPLY_ORDER' = 'UPDATE_IP_SUPPLY_ORDER',
  'CREATE_IP_SUPPLY_ORDER_FROM_API' = 'CREATE_IP_SUPPLY_ORDER_FROM_API',
  'UPDATE_MILESTONE' = 'UPDATE_MILESTONE',
  'GET_IP_SUPPLY_ORDER' = 'GET_IP_SUPPLY_ORDER',
  'UPDATE_SQ_REPORT' = 'UPDATE_SQ_REPORT',
  'DELETE_STUDY_PERSON' = 'DELETE_STUDY_PERSON',
  'GET_MILESTONE' = 'GET_MILESTONE',
  'UPDATE_SIV_QUERY' = 'UPDATE_SIV_QUERY',
  'GET_SIV_CHECKLIST' = 'GET_SIV_CHECKLIST',
  'GET_SITE_COUNTRY' = 'GET_SITE_COUNTRY',
  'UPDATE_PERSON_FICS_TRAINING' = 'UPDATE_PERSON_FICS_TRAINING',
  'GET_SQ_REPORT' = 'GET_SQ_REPORT',
  'GET_STUDY_PERSON_DETAIL' = 'GET_STUDY_PERSON_DETAIL',
  'UPDATE_SITE_IDENTIFIED_FOR_STUDY' = 'UPDATE_SITE_IDENTIFIED_FOR_STUDY',
  'CREATE_IP_SUPPLY_ORDER' = 'CREATE_IP_SUPPLY_ORDER',
  'GET_AUDIT_TRIAL' = 'GET_AUDIT_TRIAL',
  'GET_STUDY_COUNTRY' = 'GET_STUDY_COUNTRY',
  'GET_ALL_CODELIST_ITEM' = 'GET_ALL_CODELIST_ITEM',
  'GET_CODELIST_ITEM' = 'GET_CODELIST_ITEM',
  'UPDATE_ESSENTIAL_DOC' = 'UPDATE_ESSENTIAL_DOC',
  'CREATE_SIV_QUERY_RESPONSE' = 'CREATE_SIV_QUERY_RESPONSE',
  'CREATE_STARTUP_FEASIBILITY' = 'CREATE_STARTUP_FEASIBILITY',
  'CREATE_SIV_QUERY' = 'CREATE_SIV_QUERY',
  'GET_AUDIT_TRIAL_FILTERS' = 'GET_AUDIT_TRIAL_FILTERS',
  'UPDATE_PERSON_FICS_TRAIN_REQ' = 'UPDATE_PERSON_FICS_TRAIN_REQ',
  'GET_SITE_STUDY_PERSONNEL_DETAILS' = 'UPDATE_PERSON_FICS_TRAIN_REQ',
  'GET_MAJOR_MILESTONE_SUMMARY' = 'GET_MAJOR_MILESTONE_SUMMARY',
  'UPDATE_SQ_CHECKLIST' = 'UPDATE_SQ_CHECKLIST',
  'UPDATE_SIV_REPORT' = 'UPDATE_SIV_REPORT',
  'CREATE_FILEMASTER_FILE_UPLOAD' = 'CREATE_FILEMASTER_FILE_UPLOAD',
  'GET_SQ_CHECKLIST' = 'GET_SQ_CHECKLIST',
  'GET_ALL_SITE_PERSONNEL_LIST' = 'GET_ALL_SITE_PERSONNEL_LIST',
  'GET_MILESTONE_GANTT' = 'GET_MILESTONE_GANTT',
  'CREATE_SQ_REPORT' = 'CREATE_SQ_REPORT',
  'UPDATE_STARTUP_FEASIBILITY' = 'UPDATE_STARTUP_FEASIBILITY',
  'CREATE_IP_RELEASE' = 'CREATE_IP_RELEASE',
  'CREATE_STUDY_PERSON' = 'CREATE_STUDY_PERSON',
  'UPDATE_CODELIST_ITEM' = 'UPDATE_CODELIST_ITEM',
  'DELETE_SIV_QUERY' = 'DELETE_SIV_QUERY',
  'GET_MILESTONE_FILTERED' = 'GET_MILESTONE_FILTERED',
  'GET_ALL_MILESTONES' = 'GET_ALL_MILESTONES',
  'CREATE_REQUEST_ACCESS_PERSONNEL' = 'CREATE_REQUEST_ACCESS_PERSONNEL',
  'GET_ALL_STUDY_ID' = 'GET_ALL_STUDY_ID',
  'GET_SIV_QUERY_RESPONSE' = 'GET_SIV_QUERY_RESPONSE',
  'CREATE_SQ_CHECKLIST' = 'CREATE_SQ_CHECKLIST',
  'GET_STUDY' = 'GET_STUDY',
  'UPDATE_MILESTONE_BY_ID' = 'UPDATE_MILESTONE_BY_ID',
  'GET_ALL_STUDY_PERSON_DETAILS' = 'GET_ALL_STUDY_PERSON_DETAILS',
  'CREATE_CODELIST_ITEM' = 'CREATE_CODELIST_ITEM',
  'DELETE_FILEMASTER_FILE' = 'DELETE_FILEMASTER_FILE',
  'UPDATE_MILESTONE_STATUS' = 'UPDATE_MILESTONE_STATUS',
  'GET_ALL_ESSENTIAL_DOC' = 'GET_ALL_ESSENTIAL_DOC',
  'GET_FILEMASTER_FILE' = 'GET_FILEMASTER_FILE',
  'GET_IP_SUPPLY_ORDER_FROM_API' = 'GET_IP_SUPPLY_ORDER_FROM_API',
  'GET_STARTUP_FEASIBILITY' = 'GET_STARTUP_FEASIBILITY',
  'GET_BUDGET' = 'GET_BUDGET',
  'GET_SIV_REPORT' = 'GET_SIV_REPORT'
}

export enum ISFUI {
  'VIEW_LANDING_PAGE' = 'VIEW_LANDING_PAGE',
  'SEARCH_DOCUMENTS' = 'SEARCH_DOCUMENTS',
  'VIEW_SITE_MILESTONES' = 'VIEW_SITE_MILESTONES',
  'VIEW_SITE_PLANNING' = 'VIEW_SITE_PLANNING',
  'UPLOAD_DOCUMENTS' = 'UPLOAD_DOCUMENTS',
  'VIEW_UPLOADED_DOCUMENTS' = 'VIEW_UPLOADED_DOCUMENTS',
  'VIEW_ISF_BINDER_VIEWER' = 'VIEW_ISF_BINDER_VIEWER',
  'VIEW_TASKS' = 'VIEW_TASKS'
  // "UPDATE_DOCUMENT_DETAILS" = "UPDATE_DOCUMENT_DETAILS",
  // "DELETE_DOCUMENT" = "DELETE_DOCUMENT",
  // "EXPORT_SEARCH_RESULTS" = "EXPORT_SEARCH_RESULTS",
  // "SEND_DOCUMENT_AS_LINK" = "SEND_DOCUMENT_AS_LINK"
}

export interface IAccess {
  account: string;
  'isf-ui': string;
}

export enum AccessRoles {
  'manage-account' = 'manage-account',
  'view-applications' = 'view-applications',
  'view-consent' = 'view-consent',
  'manage-account-links' = 'manage-account-links',
  'manage-consent' = 'manage-consent',
  'delete-account' = 'delete-account',
  'view-profile' = 'view-profile'
}

export type KeycloakResourceAccess = {
  [key in keyof IAccess]: KeycloakRoles;
};

export interface KeycloakRoles {
  roles: Array<AccessRoles>;
}

export interface IAPI {
  'isf-api': {
    roles: Array<ISFAPI>;
  };
}

export interface IUI {
  'isf-ui': {
    roles: Array<ISFUI>;
  };
}

export interface IISFAPI {
  'isf-api': {
    roles: Array<ISFAPI>;
  };
}

export interface IUserPreferences {
  default_app: string;
  language: string;
  date_format: string;
  id?: string;
}
export interface IUser {
  email_verified: boolean;
  family_name: string;
  given_name: string;
  name: string;
  preferred_username: string;
  preferences?: IUserPreferences;
  resourceAccess: IAPI & IUI & IISFAPI;
  realmAccess: KeycloakRoles;
  token: string;
  refreshToken: string;
  loggedInTime: string;
  groups: any;
  userdataavailable: boolean;
  firstName: string;
  lastName: string;
  sessionId: any;
  userdocpermissions: any;
  sponsor: string;
  sponsor_sponsor_name: any;
  sponsorToken: any;
  siteToken: any;
}

export enum ISFAPI {
  'GET_ARTI_NAME_NUM_BY_LEVEL' = 'GET_ARTI_NAME_NUM_BY_LEVEL',
  'UPDATE_DOC_METADATA' = 'UPDATE_DOC_METADATA',
  'GET_FILE_COMMENTS' = 'GET_FILE_COMMENTS',
  'CREATE_PRESET_FILTER' = 'CREATE_PRESET_FILTER',
  'DELETE_DOC_FILE' = 'DELETE_DOC_FILE',
  'GET_ALL_COMMENT_RESPONSE' = 'GET_ALL_COMMENT_RESPONSE',
  'GET_DOC_VERSION_DETAILS' = 'GET_DOC_VERSION_DETAILS',
  'LINK_QC_USER' = 'LINK_QC_USER',
  'GET_ALL_QC_DOCS' = 'GET_ALL_QC_DOCS',
  'GET_DOC_DETAILS_BY_QUERY' = 'GET_DOC_DETAILS_BY_QUERY',
  'UPDATE_INLINE_DOC_METADATA' = 'UPDATE_INLINE_DOC_METADATA',
  'GET_AUDIT_FILTER' = 'GET_AUDIT_FILTER',
  'GET_ARTI_NAME_BY_LEVEL' = 'GET_ARTI_NAME_BY_LEVEL',
  'UPDATE_COMMENT_RESPONSE' = 'UPDATE_COMMENT_RESPONSE',
  'GET_DOC_DETAILS' = 'GET_DOC_DETAILS',
  'CREATE_DOC_METADATA' = 'CREATE_DOC_METADATA',
  'uma_protection' = 'uma_protection',
  'GET_BINDER_VIEW' = 'GET_BINDER_VIEW',
  'CREATE_FILE_COMMENTS' = 'CREATE_FILE_COMMENTS',
  'CREATE_QC_DOC' = 'CREATE_QC_DOC',
  'GET_DOC_INFO' = 'GET_DOC_INFO',
  'UPLOAD_FILE' = 'UPLOAD_FILE',
  'GET_ALL_PRESET_FILTERS' = 'GET_ALL_PRESET_FILTERS',
  'ADD_COMMENT_RESPONSE' = 'ADD_COMMENT_RESPONSE',
  'GET_DOC_STATUS_BY_ARTIFACT' = 'GET_DOC_STATUS_BY_ARTIFACT',
  'SEARCH_AUDIT' = 'SEARCH_AUDIT',
  'DOWNLOAD_FILE' = 'DOWNLOAD_FILE',
  'UPDATE_QC_DOC' = 'UPDATE_QC_DOC',
  'DELETE_COMMENT_RESPONSE' = 'DELETE_COMMENT_RESPONSE',
  'GET_QC_DOC_BY_ID' = 'GET_QC_DOC_BY_ID'
}
